export const languageOptions = [
  { value: 'en', label: 'EN' },
  { value: 'fr', label: 'FR' },
  { value: 'de', label: 'DE' },
  { value: 'es', label: 'ES' },
  { value: 'cs', label: 'CS' },
  { value: 'zh', label: 'ZH CN' },
  { value: 'zh_tw', label: 'ZH TW'},
  { value: 'ja', label: 'JA' },
  { value: 'ko', label: 'KO' },
]

const languagesWithSpecialCharacters = ['ja', 'ko'];

export const hasSpecialCharacters = language => languagesWithSpecialCharacters.includes(language);

export const fonts = '"Roboto", "Helvetica", "Arial", sans-serif';

export const specialFonts = '"Noto Sans", ' + fonts;



// WEBPACK FOOTER //
// ./src/constants/languageOptions.js